import {
  LOGOUT,
  SESSION_SUCCESS,
  LOGIN_SUCCESS,
  VERIFY_PASSWORD_SUCCESS
} from './auth';
import subscriptionTiming from '../../utils/subscription-timing';

const LOAD_OFFERS = 'subscriptions/LOAD_OFFERS';
const LOAD_OFFERS_SUCCESS = 'subscriptions/LOAD_OFFERS_SUCCESS';
const LOAD_OFFERS_FAIL = 'subscriptions/LOAD_OFFERS_FAIL';
// const LIST = 'subscriptions/LIST';
// const LIST_SUCCESS = 'subscriptions/LIST_SUCCESS';
// const LIST_FAIL = 'subscriptions/LIST_FAIL';
const CREATE = 'subscriptions/CREATE';
const CREATE_SUCCESS = 'subscriptions/CREATE_SUCCESS';
export const CREATE_FAIL = 'subscriptions/CREATE_FAIL';
const CHANGE = 'subscriptions/CHANGE';
export const CHANGE_SUCCESS = 'subscriptions/CHANGE_SUCCESS';
const CHANGE_FAIL = 'subscriptions/CHANGE_FAIL';
// const LOAD = 'subscriptions/LOAD';
// const LOAD_SUCCESS = 'subscriptions/LOAD_SUCCESS';
// const LOAD_FAIL = 'subscriptions/LOAD_FAIL';
// const UPDATE = 'subscriptions/UPDATE';
// const UPDATE_SUCCESS = 'subscriptions/UPDATE_SUCCESS';
// const UPDATE_FAIL = 'subscriptions/UPDATE_FAIL';
const UNSUBSCRIBE_REASON = 'subscriptions/UNSUBSCRIBE_REASON';
const UNSUBSCRIBE_REASON_SUCCESS = 'subscriptions/UNSUBSCRIBE_REASON_SUCCESS';
const UNSUBSCRIBE_REASON_FAIL = 'subscriptions/UNSUBSCRIBE_REASON_FAIL';
const CANCEL = 'subscriptions/CANCEL';
const CANCEL_SUCCESS = 'subscriptions/CANCEL_SUCCESS';
const CANCEL_FAIL = 'subscriptions/CANCEL_FAIL';
const MANUAL_CANCEL = 'subscriptions/MANUAL_CANCEL';
export const MANUAL_CANCEL_SUCCESS = 'subscriptions/MANUAL_CANCEL_SUCCESS';
const MANUAL_CANCEL_FAIL = 'subscriptions/MANUAL_CANCEL_FAIL';

const TRANSACTIONS = 'subscriptions/TRANSACTIONS';
const TRANSACTIONS_SUCCESS = 'subscriptions/TRANSACTIONS_SUCCESS';
const TRANSACTIONS_FAIL = 'subscriptions/TRANSACTIONS_FAIL';
const TRANSACTION_SINGLE = 'subscriptions/TRANSACTIONS_SINGLE';
const TRANSACTION_SINGLE_SUCCESS = 'subscriptions/TRANSACTION_SINGLE_SUCCESS';
const TRANSACTION_SINGLE_FAIL = 'subscriptions/TRANSACTION_SINGLE_FAIL';

const REACTIVATE = 'subscription/REACTIVATE';
export const REACTIVATE_SUCCESS = 'subscription/REACTIVATE_SUCCESS';
const REACTIVATE_FAIL = 'subscription/REACTIVATE_FAIL';

const API_ENDPOINT = '/api/subscriptions';

export const initialState = {
  offers: [],
  list: [],
  subscriber: false,
  transactions: {
    current: null,
    list: []
  }
};

// function mergeSubscriptions (list, subscription) {
//   let found = false;
//
//   const newList = list.map((item) => {
//     if (item._id === subscription._id) {
//       found = true;
//       return subscription;
//     }
//     return item;
//   });
//
//   if (!found) {
//     newList.push(subscription);
//   }
//
//   return newList;
// }

export default function subscriptions(
  state = initialState,
  { type, payload } = {}
) {
  switch (type) {
    // Auth actions
    case LOGOUT:
      return {
        ...state,
        list: [],
        subscriber: false
      };
    case TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: {
          ...state.transactions,
          list: payload
        }
      };
    case TRANSACTION_SINGLE_SUCCESS:
      return {
        ...state,
        transactions: {
          ...state.transactions,
          current: payload
        }
      };
    case SESSION_SUCCESS:
    case LOGIN_SUCCESS:
    case VERIFY_PASSWORD_SUCCESS:
      return {
        ...state,
        list: payload.subscriptions,
        subscriber: Boolean(payload.subscriptions.length)
      };

    case LOAD_OFFERS_SUCCESS:
      return {
        ...state,
        offers: payload
      };

    // case LIST_SUCCESS:
    //   return {
    //     ...state,
    //     list: payload
    //   };

    case CHANGE_SUCCESS:
    case REACTIVATE_SUCCESS: {
      // const subscriptions = state.list.filter(sub => sub._id !== payload._id);
      // subscriptions.push(payload);
      return {
        ...state,
        list: payload.data //subscriptions
      };
    }

    case CREATE_SUCCESS:
      subscriptionTiming.start();
      return {
        ...state,
        list: [payload].concat(state.list),
        subscriber: true
      };
    //  case LOAD_SUCCESS:
    //  case UPDATE_SUCCESS:
    case CANCEL_SUCCESS:
      return {
        ...state,
        list: payload.data, //mergeSubscriptions(state.list, payload),
        subscriber: true
      };
  }
  return state;
}

export function getOffers() {
  return {
    types: [LOAD_OFFERS, LOAD_OFFERS_SUCCESS, LOAD_OFFERS_FAIL],
    promise: client => client.get(`${API_ENDPOINT}/offers`)
  };
}

// export function getSubscriptions () {
//   return {
//     types: [LIST, LIST_SUCCESS, LIST_FAIL],
//     promise: client => client.get(`${API_ENDPOINT}`)
//   };
// }

export function createSubscription(data) {
  return {
    types: [CREATE, CREATE_SUCCESS, CREATE_FAIL],
    promise: client => client.post(`${API_ENDPOINT}`, { data })
  };
}

// export function getSubscription (id) {
//   return {
//     types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
//     promise: client => client.get(`${API_ENDPOINT}/${id}`)
//   };
// }

// export function updateSubscription (id, data) {
//   return {
//     types: [UPDATE, UPDATE_SUCCESS, UPDATE_FAIL],
//     promise: client => client.post(`${API_ENDPOINT}/${id}`, { data })
//   };
// }

export function changeSubscription(data) {
  return {
    types: [CHANGE, CHANGE_SUCCESS, CHANGE_FAIL],
    promise: client => client.post(`${API_ENDPOINT}/change`, { data })
  };
}

export function reactivate(id) {
  return {
    types: [REACTIVATE, REACTIVATE_SUCCESS, REACTIVATE_FAIL],
    promise: client => client.get(`${API_ENDPOINT}/reactivate/${id}`)
  };
}

export function cancelSubscription(id) {
  return {
    types: [CANCEL, CANCEL_SUCCESS, CANCEL_FAIL],
    promise: client => client.delete(`${API_ENDPOINT}/${id}`)
  };
}

export function unsubscribeManual(data) {
  return {
    types: [MANUAL_CANCEL, MANUAL_CANCEL_SUCCESS, MANUAL_CANCEL_FAIL],
    promise: client => client.post(`${API_ENDPOINT}/cancel`, { data })
  };
}

export function unsubscribeReason({ uuid, ...data }) {
  return {
    types: [
      UNSUBSCRIBE_REASON,
      UNSUBSCRIBE_REASON_SUCCESS,
      UNSUBSCRIBE_REASON_FAIL
    ],
    promise: client => client.post(`${API_ENDPOINT}/cancel/${uuid}`, { data })
  };
}

export function getTransactions() {
  return {
    types: [TRANSACTIONS, TRANSACTIONS_SUCCESS, TRANSACTIONS_FAIL],
    promise: client => client.get(`${API_ENDPOINT}/transactions`)
  };
}

export function getSingleTransaction(id) {
  return {
    types: [
      TRANSACTION_SINGLE,
      TRANSACTION_SINGLE_SUCCESS,
      TRANSACTION_SINGLE_FAIL
    ],
    promise: client => client.get(`${API_ENDPOINT}/transactions/${id}`)
  };
}
